/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SeasonsRecordCommentsRecordCommentModel } from './seasons-record-comments-record-comment-model';
import { SeasonsPlansPlanLightModel } from './seasons-plans-plan-light-model';
import { IncentiveRecordsAssignmentLetterModel } from './incentive-records-assignment-letter-model';
import { IncentiveEmployeesEmployeeSnapshotModel } from './incentive-employees-employee-snapshot-model';
import { SeasonsSeasonsSeasonLightModel } from './seasons-seasons-season-light-model';
import { IncentiveRecordsRecordLetterStateModel } from './incentive-records-record-letter-state-model';
import { SeasonsMembersMemberLightModel } from './seasons-members-member-light-model';

export interface IncentiveRecordsAssignmentRecordPartnerModel {
  id?: string;
  assignmentId?: string | null;
  reassignmentId?: string | null;
  memberId?: string | null;
  creationContext?: IncentiveRecordsAssignmentRecordPartnerModelCreationContextEnum;
  state?: IncentiveRecordsAssignmentRecordPartnerModelStateEnum;
  startDate?: string;
  endDate?: string;
  member?: SeasonsMembersMemberLightModel;
  plan?: SeasonsPlansPlanLightModel;
  season?: SeasonsSeasonsSeasonLightModel;
  letters?: Array<IncentiveRecordsAssignmentLetterModel> | null;
  initialSnapshot?: IncentiveEmployeesEmployeeSnapshotModel;
  durationInCalenderDays?: number;
  proration?: number;
  proratedTiaLocalCurrency?: number;
  proratedTiaEuro?: number;
  ippAchievementValue?: number;
  payoutAmount?: number;
  payoutAmountInEuro?: number;
  totalTargetAchievement?: number;
  unitTargetAchievement?: number;
  unitTargetPayoutAmount?: number;
  unitTargetPayoutAmountInEuro?: number;
  individualMultiplierValue?: number;
  comments?: Array<SeasonsRecordCommentsRecordCommentModel> | null;
  payoutState?: IncentiveRecordsAssignmentRecordPartnerModelPayoutStateEnum | null;
  payoutDate?: string;
  exportState?: IncentiveRecordsAssignmentRecordPartnerModelExportStateEnum;
  definedPayoutPercentage?: number | null;
  recordLetterStates?: Array<IncentiveRecordsRecordLetterStateModel> | null;
  processState?: IncentiveRecordsAssignmentRecordPartnerModelProcessStateEnum;
}
export enum IncentiveRecordsAssignmentRecordPartnerModelCreationContextEnum {
  IncentiveProcess = 'IncentiveProcess',
  Reassignment = 'Reassignment',
  Manual = 'Manual',
  SogProcess = 'SogProcess',
  LetterAndPayroll = 'LetterAndPayroll',
  Other = 'Other'
}
export enum IncentiveRecordsAssignmentRecordPartnerModelStateEnum {
  Active = 'Active',
  Draft = 'Draft',
  Outdated = 'Outdated',
  Irrelevant = 'Irrelevant'
}
export enum IncentiveRecordsAssignmentRecordPartnerModelPayoutStateEnum {
  StandardPayout = 'StandardPayout',
  FullPayout = 'FullPayout',
  DefinedPayoutEndOfFiscalYear = 'DefinedPayoutEndOfFiscalYear',
  NoPayout = 'NoPayout',
  Irrelevant = 'Irrelevant'
}
export enum IncentiveRecordsAssignmentRecordPartnerModelExportStateEnum {
  Open = 'Open',
  Done = 'Done'
}
export enum IncentiveRecordsAssignmentRecordPartnerModelProcessStateEnum {
  None = 'None',
  Open = 'Open',
  TafCreated = 'TafCreated',
  TafPublished = 'TafPublished',
  ReadyForCalculation = 'ReadyForCalculation',
  Calculated = 'Calculated',
  Frozen = 'Frozen',
  AchievementLetterCreated = 'AchievementLetterCreated',
  AchievementLetterPublished = 'AchievementLetterPublished'
}
